import { clsx } from 'clsx';
import { ModuleType } from 'game/state/BotState';
import times from 'lodash/times';
import { ModuleComponentProps } from './ModuleProps';
import { moduleStyles } from './moduleStyles';

type LogicModuleProps = ModuleComponentProps<ModuleType.Logic>;

export const LogicModule: React.FC<LogicModuleProps> = ({
  module,
  bot,
  grabbing,
  onGrabStart,
}) => {
  const cache = bot.props.state.cache[module.id];
  return (
    <>
      {module.operation === 'fallback' ? (
        <path
          fill="#f2f2f2"
          stroke="#4d4d4d"
          d="M0.5 0.5H200.5V600.5H0.5z"
        />
      ) : (
        <path
          fill="#333333"
          stroke="#000000"
          d="M0.5 0.5H200.5V600.5H0.5z"
        />
      )}
      <rect width="179" height="379" x="11" y="101" rx="10.92" />
      <path
        fill="#fff"
        d="M761.58 184.94A10.43 10.43 0 01772 195.36v357.16a10.43 10.43 0 01-10.42 10.42H604.42A10.43 10.43 0 01594 552.52V195.36a10.43 10.43 0 0110.42-10.42h157.16m0-1H604.42A11.42 11.42 0 00593 195.36v357.16a11.42 11.42 0 0011.42 11.42h157.16A11.42 11.42 0 00773 552.52V195.36a11.42 11.42 0 00-11.42-11.42z"
        transform="translate(-582.5 -83.44)"
      />
      {module.operation === 'fallback' ? (
        <path d="M23.53 62.82V39.51H44.9V43H27.06v6.42H41.4v3.49H27.06v9.91zM51.77 62.82a4 4 0 01-2.13-.58 4.48 4.48 0 01-1.52-1.54 4 4 0 01-.56-2.09v-6.93h15.57v-3.33a.77.77 0 00-.23-.57.72.72 0 00-.55-.24H47.56V44h14.89a4 4 0 012.12.58 4.31 4.31 0 011.52 1.54 4 4 0 01.57 2.09v14.61zm.09-3.5h11.27V55H51.05v3.56a.75.75 0 00.25.57.77.77 0 00.56.19zM72.44 62.24a4.54 4.54 0 01-1.54-1.54 3.92 3.92 0 01-.58-2.09V37.89h3.5v20.62a.82.82 0 00.81.81H78v3.5h-3.5a3.92 3.92 0 01-2.06-.58zM83.58 62.24A4.54 4.54 0 0182 60.7a3.92 3.92 0 01-.58-2.09V37.89H85v20.62a.82.82 0 00.8.81h3.41v3.5h-3.5a3.92 3.92 0 01-2.13-.58zM92.56 62.82V37.89h3.5V44h11.4a4 4 0 012.12.58 4.39 4.39 0 011.52 1.54 4 4 0 01.57 2.09v10.4a4 4 0 01-.57 2.09 4.39 4.39 0 01-1.52 1.54 4 4 0 01-2.12.58zm4.31-3.5h10.49a.82.82 0 00.81-.81V48.35a.82.82 0 00-.81-.81H96.87a.8.8 0 00-.57.24.78.78 0 00-.24.57v10.16a.78.78 0 00.24.57.8.8 0 00.57.24zM119 62.82a4 4 0 01-2.12-.58 4.42 4.42 0 01-1.53-1.54 4.09 4.09 0 01-.56-2.09v-6.93h15.57v-3.33a.8.8 0 00-.22-.57.75.75 0 00-.55-.24h-14.8V44h14.89a4 4 0 012.12.58 4.42 4.42 0 011.53 1.54 4.09 4.09 0 01.56 2.09v14.61zm.09-3.5h11.27V55h-12.09v3.56a.79.79 0 00.25.57.77.77 0 00.56.19zM139.53 62.24A4.63 4.63 0 01138 60.7a4 4 0 01-.58-2.09V48.25a4 4 0 01.58-2.09 4.63 4.63 0 011.54-1.54 4 4 0 012.09-.58h14.83v3.5h-14.74a.82.82 0 00-.81.81v10.16a.82.82 0 00.81.81h14.8v3.5h-14.9a4 4 0 01-2.09-.58zM160.08 62.82V37.89h3.5v13.79h4.2l7-7.64h4v.65l-7.94 8.74 7.94 8.74v.65h-4l-7-7.64h-4.2v7.64z" />
      ) : (
        <path
          fill="#fff"
          d="M598.79 146.26a4.06 4.06 0 01-2.12-.57 4.26 4.26 0 01-1.52-1.52 4.06 4.06 0 01-.57-2.12v-1.36h3.5V142a.82.82 0 00.81.81h14.7a.72.72 0 00.55-.24.81.81 0 00.23-.57v-4.79a.78.78 0 00-.23-.58.71.71 0 00-.55-.23h-14.8a4.06 4.06 0 01-2.12-.57 4.18 4.18 0 01-1.52-1.52 4.06 4.06 0 01-.57-2.12v-5a4.08 4.08 0 01.57-2.12 4.34 4.34 0 011.52-1.52 4.06 4.06 0 012.12-.57h14.9a4.08 4.08 0 012.12.57 4.42 4.42 0 011.52 1.52 4.08 4.08 0 01.57 2.12v1.36h-3.53v-1.26a.83.83 0 00-.23-.57.72.72 0 00-.55-.24h-14.7a.78.78 0 00-.57.24.8.8 0 00-.24.57V132a.75.75 0 00.24.58.77.77 0 00.57.23h14.8a4.08 4.08 0 012.12.57 4.34 4.34 0 011.52 1.52 4.06 4.06 0 01.57 2.12v5a4.06 4.06 0 01-.57 2.12 4.34 4.34 0 01-1.52 1.52 4.08 4.08 0 01-2.12.57zM623.35 145.67a4.6 4.6 0 01-1.54-1.53 4 4 0 01-.58-2.09v-10.36a4 4 0 01.58-2.09 4.63 4.63 0 011.54-1.54 4 4 0 012.09-.58h10.69a4 4 0 012.12.58 4.48 4.48 0 011.52 1.54 4 4 0 01.57 2.09v6.93h-15.61V142a.82.82 0 00.81.81h14.8v3.5h-14.9a4 4 0 01-2.09-.64zm1.38-10.32h12.08v-3.57a.8.8 0 00-.23-.56.7.7 0 00-.58-.22h-10.46a.75.75 0 00-.57.25.77.77 0 00-.24.56zM658.24 153.71v-7.45h-11.4a4 4 0 01-2.12-.59 4.45 4.45 0 01-1.52-1.53 4 4 0 01-.57-2.09v-10.36a4 4 0 01.57-2.09 4.48 4.48 0 011.52-1.54 4 4 0 012.12-.58h14.9v26.23zm-11.27-11h10.5a.75.75 0 00.55-.24.8.8 0 00.22-.57v-10.12a.79.79 0 00-.22-.56.73.73 0 00-.55-.25H647a.75.75 0 00-.56.25.78.78 0 00-.25.56V142a.79.79 0 00.25.57.77.77 0 00.56.19zM666.58 145.67a4.37 4.37 0 01-1.52-1.53 4 4 0 01-.57-2.09v-14.57H668V142a.82.82 0 00.81.81h10.49a.81.81 0 00.57-.24.78.78 0 00.24-.57v-14.52h3.5v14.57a4 4 0 01-.57 2.09 4.45 4.45 0 01-1.52 1.53 4 4 0 01-2.12.59h-10.7a4 4 0 01-2.12-.59zM688.44 145.67a4.51 4.51 0 01-1.54-1.53 4 4 0 01-.58-2.09v-10.36a3.9 3.9 0 01.58-2.09 4.54 4.54 0 011.54-1.54 3.9 3.9 0 012.09-.58h10.68a4 4 0 012.12.58 4.31 4.31 0 011.52 1.54 4 4 0 01.57 2.09v6.93h-15.61V142a.75.75 0 00.25.57.77.77 0 00.56.24h14.8v3.5h-14.89a3.91 3.91 0 01-2.09-.64zm1.37-10.32h12.08v-3.57a.79.79 0 00-.22-.56.73.73 0 00-.56-.25h-10.49a.86.86 0 00-.81.81zM708.82 146.26v-18.78h14.9a4 4 0 012.12.58 4.48 4.48 0 011.52 1.54 4 4 0 01.57 2.09v14.57h-3.5v-14.48a.77.77 0 00-.24-.56.78.78 0 00-.57-.25h-10.49a.75.75 0 00-.57.25.77.77 0 00-.24.56v14.48zM732.67 145.67a4.51 4.51 0 01-1.54-1.53 4 4 0 01-.58-2.09v-10.36a3.9 3.9 0 01.58-2.09 4.54 4.54 0 011.54-1.54 3.92 3.92 0 012.09-.58h14.83V131h-14.73a.75.75 0 00-.57.25.77.77 0 00-.24.56V142a.82.82 0 00.81.81h14.79v3.5h-14.89a3.93 3.93 0 01-2.09-.64zM754.37 145.67a4.51 4.51 0 01-1.54-1.53 4 4 0 01-.59-2.09v-10.36a3.91 3.91 0 01.59-2.09 4.54 4.54 0 011.54-1.54 3.89 3.89 0 012.08-.58h10.69a4 4 0 012.12.58 4.39 4.39 0 011.52 1.54 4 4 0 01.57 2.09v6.93h-15.61V142a.78.78 0 00.24.57.8.8 0 00.57.24h14.8v3.5h-14.9a3.9 3.9 0 01-2.08-.64zm1.37-10.32h12.08v-3.57a.8.8 0 00-.23-.56.7.7 0 00-.59-.22h-10.45a.84.84 0 00-.81.81z"
          transform="translate(-582.5 -83.44)"
        />
      )}
      {times(5, i => {
        const y = 145 + (70 * i);
        const inputStatus = cache?.inputs[i]?.result.status;
        return (
          <path
            key={i}
            fill="#7ac943"
            opacity={(inputStatus === 'success' || inputStatus === 'running') ? 1 : 0.3}
            d={`M140 ${y}H160V${y + 10}H140Z`}
          />
        );
      })}
      <circle cx="100.5" cy="560.5" r="19.5" fill="#ccc" />
      <path
        fill="#666"
        d="M683 624.94a19 19 0 11-19 19 19 19 0 0119-19m0-1a20 20 0 1020 20 20 20 0 00-20-20z"
        transform="translate(-582.5 -83.44)"
      />
      <g fill="#fff" opacity="0.75">
        <circle cx="100.5" cy="561.5" r="9.5" />
        <path
          d="M683 635.94a9 9 0 11-9 9 9 9 0 019-9m0-1a10 10 0 1010 10 10 10 0 00-10-10z"
          transform="translate(-582.5 -83.44)"
        />
      </g>
      <circle cx="100.5" cy="560.5" r="9.5" />
      <path
        fill="#666"
        d="M683 634.94a9 9 0 11-9 9 9 9 0 019-9m0-1a10 10 0 1010 10 10 10 0 00-10-10z"
        transform="translate(-582.5 -83.44)"
      />
      <path
        d="M150.5 560.5L130.5 550.5 130.5 570.5 150.5 560.5z"
        fill={module.operation === 'fallback' ? '#000' : '#fff'}
      />
      <circle cx="100.5" cy="150.5" r="19.5" fill="#ccc" />
      <path
        fill="#666"
        d="M683 214.94a19 19 0 11-19 19 19 19 0 0119-19m0-1a20 20 0 1020 20 20 20 0 00-20-20z"
        transform="translate(-582.5 -83.44)"
      />
      <g fill="#fff" opacity="0.75">
        <circle cx="100.5" cy="151.5" r="9.5" />
        <path
          d="M683 225.94a9 9 0 11-9 9 9 9 0 019-9m0-1a10 10 0 1010 10 10 10 0 00-10-10z"
          transform="translate(-582.5 -83.44)"
        />
      </g>
      <circle cx="100.5" cy="150.5" r="9.5" />
      <path
        fill="#666"
        d="M683 224.94a9 9 0 11-9 9 9 9 0 019-9m0-1a10 10 0 1010 10 10 10 0 00-10-10z"
        transform="translate(-582.5 -83.44)"
      />
      <path
        fill="#fff"
        d="M70.5 150.5L50.5 140.5 50.5 160.5 70.5 150.5z"
      />
      <circle cx="100.5" cy="430.5" r="19.5" fill="#ccc" />
      <path
        fill="#666"
        d="M683 494.94a19 19 0 11-19 19 19 19 0 0119-19m0-1a20 20 0 1020 20 20 20 0 00-20-20z"
        transform="translate(-582.5 -83.44)"
      />
      <g fill="#fff" opacity="0.75">
        <circle cx="100.5" cy="431.5" r="9.5" />
        <path
          d="M683 505.94a9 9 0 11-9 9 9 9 0 019-9m0-1a10 10 0 1010 10 10 10 0 00-10-10z"
          transform="translate(-582.5 -83.44)"
        />
      </g>
      <circle cx="100.5" cy="430.5" r="9.5" />
      <path
        fill="#666"
        d="M683 504.94a9 9 0 11-9 9 9 9 0 019-9m0-1a10 10 0 1010 10 10 10 0 00-10-10z"
        transform="translate(-582.5 -83.44)"
      />
      <path
        fill="#fff"
        d="M70.5 430.5L50.5 420.5 50.5 440.5 70.5 430.5z"
      />
      <circle cx="100.5" cy="360.5" r="19.5" fill="#ccc" />
      <path
        fill="#666"
        d="M683 424.94a19 19 0 11-19 19 19 19 0 0119-19m0-1a20 20 0 1020 20 20 20 0 00-20-20z"
        transform="translate(-582.5 -83.44)"
      />
      <g fill="#fff" opacity="0.75">
        <circle cx="100.5" cy="361.5" r="9.5" />
        <path
          d="M683 435.94a9 9 0 11-9 9 9 9 0 019-9m0-1a10 10 0 1010 10 10 10 0 00-10-10z"
          transform="translate(-582.5 -83.44)"
        />
      </g>
      <circle cx="100.5" cy="360.5" r="9.5" />
      <path
        fill="#666"
        d="M683 434.94a9 9 0 11-9 9 9 9 0 019-9m0-1a10 10 0 1010 10 10 10 0 00-10-10z"
        transform="translate(-582.5 -83.44)"
      />
      <path
        fill="#fff"
        d="M70.5 360.5L50.5 350.5 50.5 370.5 70.5 360.5z"
      />
      <circle cx="100.5" cy="290.5" r="19.5" fill="#ccc" />
      <path
        fill="#666"
        d="M683 354.94a19 19 0 11-19 19 19 19 0 0119-19m0-1a20 20 0 1020 20 20 20 0 00-20-20z"
        transform="translate(-582.5 -83.44)"
      />
      <g fill="#fff" opacity="0.75">
        <circle cx="100.5" cy="291.5" r="9.5" />
        <path
          d="M683 365.94a9 9 0 11-9 9 9 9 0 019-9m0-1a10 10 0 1010 10 10 10 0 00-10-10z"
          transform="translate(-582.5 -83.44)"
        />
      </g>
      <circle cx="100.5" cy="290.5" r="9.5" />
      <path
        fill="#666"
        d="M683 364.94a9 9 0 11-9 9 9 9 0 019-9m0-1a10 10 0 1010 10 10 10 0 00-10-10z"
        transform="translate(-582.5 -83.44)"
      />
      <path
        fill="#fff"
        d="M70.5 290.5L50.5 280.5 50.5 300.5 70.5 290.5z"
      />
      <circle cx="100.5" cy="220.5" r="19.5" fill="#ccc" />
      <path
        fill="#666"
        d="M683 284.94a19 19 0 11-19 19 19 19 0 0119-19m0-1a20 20 0 1020 20 20 20 0 00-20-20z"
        transform="translate(-582.5 -83.44)"
      />
      <g fill="#fff" opacity="0.75">
        <circle cx="100.5" cy="221.5" r="9.5" />
        <path
          d="M683 295.94a9 9 0 11-9 9 9 9 0 019-9m0-1a10 10 0 1010 10 10 10 0 00-10-10z"
          transform="translate(-582.5 -83.44)"
        />
      </g>
      <circle cx="100.5" cy="220.5" r="9.5" />
      <path
        fill="#666"
        d="M683 294.94a9 9 0 11-9 9 9 9 0 019-9m0-1a10 10 0 1010 10 10 10 0 00-10-10z"
        transform="translate(-582.5 -83.44)"
      />
      <path
        fill="#fff"
        d="M70.5 220.5L50.5 210.5 50.5 230.5 70.5 220.5z"
      />
      <text
        fontSize="27.77"
        transform="translate(72.28 530.29)"
        fill={module.operation === 'fallback' ? '#000' : '#fff'}
      >
        OUT
      </text>

      <rect
        className={clsx(moduleStyles.grab, { [moduleStyles.grabbing]: grabbing })}
        width={200}
        height={600}
        onMouseDown={onGrabStart}
      />
    </>
  );
};
